import BaseApi from './BaseApi'

class AdviserProfilesApi extends BaseApi {

  get publishedAdviserProfilesUrl () {
    return 'adviserProfilesPublished'
  }

  getPublishedAdviserProfiles () {
    return this.getJson(this.publishedAdviserProfilesUrl)
  }

  getPublishedAdviserProfile (adviserId) {
    return this.getJson(this.publishedAdviserProfilesUrl + '/' + adviserId)
  }

  approveProfile (adviserId) {
    return this.postJson(this.publishedAdviserProfilesUrl + '/' + adviserId)
  }

}
export default AdviserProfilesApi
